import React from "react";
import { Accordion, Container } from "react-bootstrap";
import { MainHeader, Breadcrumb, MainFooter } from "../../components";

function Faqs() {
    const faq = "FAQ's"
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: faq,
        },
    ];
    return (
        <>       
            <MainHeader/>
            <main className="aboutPage">
                <Container>
                    <Breadcrumb title="FAQ's" breadcrumb={breadcrumb}/>
                    <div className="aboutPage_inner">
                        <h2 className="aboutPage_title lg mt-0 mb-0">FAQ's</h2>
                        <Accordion defaultActiveKey="1"  className="border-0 rounded-0">
                            <Accordion.Item className="rounded-0" eventKey="0">
                                <Accordion.Header>How does the Good Guys Home Services App work? </Accordion.Header>
                                <Accordion.Body>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                                minim veniam, quis nostrud exercitation.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item className="rounded-0" eventKey="1">
                                <Accordion.Header>How often should I service my HVAC and plumbing system?</Accordion.Header>
                                <Accordion.Body>
                                    We recommend a maintenance appointment for HVAC twice a year (once for heat, once for air conditioning). 
                                    For plumbing one visit a year will help to make sure you’re getting the most out of your system.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item className="rounded-0" eventKey="2">
                                <Accordion.Header>What happens when I need a repair on a holiday or weekend?</Accordion.Header>
                                <Accordion.Body>
                                    Aliquam eu rhoncus ipsum, vitae blandit nisl. Mauris imperdiet orci eu velit sagittis, id rhoncus velit fermentum. 
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item className="rounded-0" eventKey="3">
                                <Accordion.Header>Do I have to enter my credit card in the App?</Accordion.Header>
                                <Accordion.Body>
                                    Proin et nisl quam. Nulla facilisi. Etiam et augue sapien. Cras elementum leo vitae orci mollis sodales. Sed fermentum, orci eget iaculis tincidunt, tellus nisl dictum sem.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item className="rounded-0" eventKey="4">
                                <Accordion.Header>Do you have liability insurance?</Accordion.Header>
                                <Accordion.Body>
                                    Nunc bibendum, ex ut venenatis gravida, ligula justo sagittis nulla, et mollis risus nunc non eros. Sed venenatis elementum nisl ut varius. Praesent rutrum molestie malesuada.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item className="rounded-0" eventKey="5">
                                <Accordion.Header>What type of screening do you have for technicians?</Accordion.Header>
                                <Accordion.Body>
                                    Nunc bibendum, ex ut venenatis gravida, ligula justo sagittis nulla, et mollis risus nunc non eros. Sed venenatis elementum nisl ut varius. Praesent rutrum molestie malesuada.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </Container>
            </main>
            <MainFooter/>
        </>
    );
  }
  
  export default Faqs;